import CpfCnpjFilter from "./cpfCnpjFilter";
import CurrencyFilter from "./currencyFilter";
import DateFilter from "./dateFilter";
import HoraFilter from "./horaFilter";
import TelefoneFilter from "./telefoneFilter";
import LimitText from "./limitText";
import Pluralize from "./pluralize";
import UltimaObrigacao from "./ultimaObrigacao";
import Cnpj from "./cnpj";
import Capitalize from "./capitalize";
import ShortName from "./shortName";
import DateMonthFilter from "./dateMonthFilter";
import NumberRoundFilter from "./numberRoundFilter";
import DateFromNow from "./dateFromNow";
import Negative from "./negative";
import NoCurrency from "./noCurrency";
import Json from "./json";

export default {
  CpfCnpjFilter,
  CurrencyFilter,
  DateFilter,
  HoraFilter,
  TelefoneFilter,
  LimitText,
  Pluralize,
  UltimaObrigacao,
  Cnpj,
  Capitalize,
  ShortName,
  DateMonthFilter,
  NumberRoundFilter,
  DateFromNow,
  Negative,
  Json,
  NoCurrency,
};
